<template>
  <b-modal
    id="constructor-modal"
    cancel-variant="outline-secondary"
    :ok-title="isEdit ? $t('generals.save') : $t('generals.create')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    :title="isEdit ? $t('generals.edit') : $t('generals.create')"
    size="lg"
    @ok="saveClick"
  >
    <!-- @hidden="form_obj = def_form_obj" -->
    <validation-observer ref="constructorValidations">
      <h3>{{ $t('references.basic_information') }}</h3>
      <validated-form
        :form_fields="getFormFields"
        :def_form_obj="form_obj"
        @field_update="form => form_obj = form"
      />
      <hr>
      <h3>{{ $t('references.requisites') }}</h3>
      <validated-form
        :form_fields="getAccountFields"
        :def_form_obj="form_obj.account"
        @field_update="form => form_obj.account = form"
      />
      <div class="p-1 mb-1">
        <b-row
          v-for="(bank, index) in form_obj.account.banks"
          :key="index"
          class="border p-1 position-relative"
        >
          <b-col
            class="mt-1"
            md="12"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('references.bank_name')"
              rules="required"
            >
              <b-form-group :label="$t('references.bank_name')">
                <b-form-input v-model="bank.bank_name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="8">
            <validation-provider
              #default="{ errors }"
              :name="$t('references.rs')"
              rules="length:20"
            >
              <b-form-group :label="$t('references.rs')">
                <b-form-input v-model="bank.account_number" />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              :name="$t('references.mfos')"
              rules="length:5"
            >
              <b-form-group :label="$t('references.mfos')">
                <b-form-input v-model="bank.mfo" />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-button
            :title="$t('references.delete_requisite')"
            class="p-25 position-absolute"
            variant="danger"
            style="right: 15px"
            @click="deleteRequisite(index)"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </b-row>
      </div>
      <b-button @click="addRequisite">
        <feather-icon icon="PlusIcon" />
        {{ $t('references.add_bank_requisite') }}
      </b-button>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import { required, length, email } from '@validations'
import validatedForm from '@/components/validatedForm.vue'

export default {
  components: {
    BModal,
    validatedForm,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defFormObj: {
      type: Object,
      required: false,
      default() {
        return {
          account: {},
        }
      },
    },
  },
  data() {
    return {
      required,
      length,
      email,
      form_obj: {
        account: {
          banks: [
            {
              account_number: '',
              bank_name: '',
              mfo: '',
            },
          ],
        },
      },
      image_preview: '',
      account_fields: [
        [
          {
            obj_name: 'bank_name',
            label: `${this.$t('references.bank_name')}:`,
          },
          {
            obj_name: 'account_number',
            label: `${this.$t('references.rs')}:`,
            validation_rules: 'length:20',
            col_size: 8,
          },
          {
            obj_name: 'mfo',
            label: `${this.$t('references.mfos')}:`,
            validation_rules: 'length:5',
            col_size: 4,
          },
        ],
      ],
    }
  },
  computed: {
    getFormFields() {
      return [
        {
          obj_name: 'title',
          label: `${this.$t('references.title')}:`,
          col_size: 12,
        },
        {
          obj_name: 'boss',
          label: `${this.$t('references.director')}:`,
          col_size: 6,
        },
        {
          obj_name: 'accountant',
          label: `${this.$t('references.accountant')}:`,
          col_size: 6,
        },
        {
          obj_name: 'address',
          label: `${this.$t('references.address')}:`,
        },
        {
          obj_name: 'email',
          label: 'E-mail:',
          validation_rules: 'email',
          col_size: 6,
        },
        {
          obj_name: 'phone_number',
          label: `${this.$t('references.phone_number')}:`,
          col_size: 6,
          props: {
            class: 'form-control',
            'lazy-formatter': true,
            formatter: val => this.phoneFormat(val),
          },
        },
        // {
        //   obj_name: 'phone_number',
        //   label: 'Номер телефона',
        //   component_name: 'cleave',
        //   props: {
        //     class: 'form-control',
        //     options: {
        //       prefix: '+998',
        //       blocks: [4, 2, 3, 2, 2],
        //       delimiter: '-',
        //     },
        //     raw: true,
        //   },
        //   col_size: 6,
        // },
        {
          obj_name: 'shape_base',
          label: `${this.$t('references.form_base')}:`,
        },
      ]
    },
    getAccountFields() {
      return [
        {
          obj_name: 'inn',
          label: `${this.$t('references.inn')}:`,
          validation_rules: 'length:9',
          col_size: 4,
        },
        {
          obj_name: 'nds',
          label: `${this.$t('references.vat')}:`,
          validation_rules: 'length:12',
          col_size: 4,
        },
        {
          obj_name: 'oked',
          label: `${this.$t('references.okved')}:`,
          validation_rules: 'length:5',
          col_size: 4,
        },
        // {
        //   obj_name: 'bank_name',
        //   label: `${this.$t('references.bank_name')}:`,
        // },
        // {
        //   obj_name: 'account_number',
        //   label: `${this.$t('references.rs')}:`,
        //   validation_rules: 'length:20',
        //   col_size: 8,
        // },
        // {
        //   obj_name: 'mfo',
        //   label: `${this.$t('references.mfos')}:`,
        //   validation_rules: 'length:5',
        //   col_size: 4,
        // },
      ]
    },
  },
  watch: {
    defFormObj() {
      this.form_obj = this.defFormObj
    },
  },
  mounted() {
    this.form_obj = this.defFormObj
  },
  methods: {
    ...mapActions('knowledgeBase', ['CREATE_CONSTRUCTOR', 'EDIT_CONSTRUCTOR']),
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.constructorValidations.validate().then(success => {
        if (success) {
          console.log(this.form_obj)
          this.form_obj.phone_number = this.form_obj.phone_number.replace(/[^0-9]+/gi, '')
          this.$set(this.form_obj.account, 'phone_number', this.form_obj.phone_number)
          this.$set(this.form_obj.account, 'email', this.form_obj.email)
          this.$delete(this.form_obj, 'phone_number')
          this.$delete(this.form_obj, 'email')
          if (this.isEdit) {
            this.EDIT_CONSTRUCTOR(this.form_obj).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('constructor-modal')
              this.$_successToast(this.$t('generals.changed'))
            }).catch(() => {
              this.$_errorToast(this.$t('generals.error'))
            })
          } else {
            this.CREATE_CONSTRUCTOR(this.form_obj).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('constructor-modal')
              this.$_successToast(this.$t('generals.added'))
            }).catch(() => {
              this.$_errorToast(this.$t('generals.error'))
            })
          }
        }
      })
    },
    addRequisite() {
      this.form_obj.account.banks.push(
        {
          account_number: '',
          bank_name: '',
          mfo: '',
        },
      )
    },
    deleteRequisite(index) {
      this.form_obj.account.banks.splice(index, 1)
    },
    phoneFormat(phoneNumberString) {
      const cleaned = (`${phoneNumberString}`).replace(/\D/g, '')
      const match = cleaned.match(/^(998|)?(\d{2})(\d{3})(\d{2})(\d{2})$/)
      if (match) {
        const intlCode = (match[1] ? '+998 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4], '-', match[5]].join('')
      }
      return null
    },
  },
}
</script>

<style></style>
